import React from 'react';
import { ModalBody, ModalCloseBtn, ModalFooter, ModalHeader, useModalContext } from '@fiverr-private/overlay';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { CheckCircleSolidIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../utils/i18n';
import { AdminMember } from '../../../types';

interface SuccessMessageProps {
    admin: AdminMember;
}

export const SuccessMessage = ({ admin }: SuccessMessageProps) => {
    const { close } = useModalContext();

    return (
        <>
            <ModalHeader>
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Stack
                    paddingTop="20"
                    paddingBottom="28"
                    gap="3"
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                >
                    <CheckCircleSolidIcon size="lg" color="green_700" />
                    <Text paddingTop="3" size="b_xxl" fontWeight="bold" textAlign="center">
                        <AppI18n k="request_upgrade_modal.success_message.title" />
                    </Text>
                    <Text textAlign="center">
                        <AppI18n
                            k="request_upgrade_modal.success_message.description"
                            params={{ adminEmail: admin.email }}
                        />
                    </Text>
                </Stack>
            </ModalBody>
            <ModalFooter>
                <Button onClick={close}>
                    <AppI18n k="request_upgrade_modal.success_message.cta" />
                </Button>
            </ModalFooter>
        </>
    );
};
